




























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import fieldData from "@/ts/FormData";
import func from "@/ts/FormFunctions";
import VueTimepicker from "vuejs-timepicker";
import api from "@/ts/functions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { IRockCrushingPermitVueModel } from '@/ts/models/IRockCrushingPermitVueModel';
import AddressInfo from "@/views/shared/AddressInfo.vue";
import ContactInfo from "@/views/permits/RockCrushing/ContactInfo.vue";
import { IContactVueModel } from "@/ts/models/IContactVueModel";
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';
import cloneDeep from 'lodash/fp/cloneDeep';
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import Datepicker from 'vuejs-datepicker';

@Component({
    props: {
        form: {
            type: Object as () => IRockCrushingPermitVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        },
        isRenewal: {
            type: Boolean
        }
    },
    components: {
        VueTimepicker, AddressInfo, ContactInfo, VueSimpleSuggest, Datepicker
    }
})
export default class SiteInfo extends Vue {
    name: string = "SiteInfo";
    title: string = "";
    index: number = NaN;
    isFacilityAddressError: boolean = false;
    isApplicantContactError: boolean = false;
    isPropertyOwnerError: boolean = false;
    errorMsgs = ErrorMessages;
    facilities: any = null;
    facility: any = null;
    mounted(): void {
        this.initializeComponent(this.name);
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });
        
        this.$props.vueStates.views[this.index].visited = true;
    }
    monthCheckboxUpdate(monthNumber: number): void {
      if (monthNumber == 1) {
        this.$props.form.twoMonths = false;
        this.$props.form.threeMonths = false;
        this.$props.form.fees[0].amount = this.$props.form.oneMonth == true ? 500 : 0;
      }
      else if (monthNumber == 2) {
        this.$props.form.oneMonth = false;
        this.$props.form.threeMonths = false;
        this.$props.form.fees[0].amount = this.$props.form.twoMonths == true ? 1000 : 0;
      }
      else if (monthNumber == 3) {
        this.$props.form.oneMonth = false;
        this.$props.form.twoMonths = false;
        this.$props.form.fees[0].amount = this.$props.form.threeMonths == true ? 1500 : 0;
      }
    }
  
    //Does the work of hasErrors, but checks on every input change and validates owners and operators
  //TODO: add in actual validations for the page here
    checkStatus(): void {
        this.$props.vueStates.views[this.index].error = this.hasErrors;
    }

    isTimeError(isOpen: boolean, time: any): boolean {
        if (isOpen) {
            return func.isNullOrEmpty(time.h) || func.isNullOrEmpty(time.mm) || func.isNullOrEmpty(time.a);
        }
        return false;
    }

    get isFacilityNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.facilityBuildingName);
    }
    
    get isMonthsError(): boolean {
      return !(this.$props.form.oneMonth || this.$props.form.twoMonths || this.$props.form.threeMonths);
    }
    
    get isFacilityTypeError(): boolean {
      return func.isNullOrEmpty(this.$props.form.facilityType);
    }

    get isDivisionSiteIdError(): boolean {
        return func.isNullOrEmpty(this.$props.form.divisionSiteId);
    }
    
    get isApplicationDateError(): boolean {
      return this.$props.form.dateOfApplication == null;
    }
    
    get isAnticipatedStartDateError(): boolean {
      return this.$props.form.anticipatedStartDate == null;
    }
    
    get isAnticipatedEndDateError(): boolean {
      return this.$props.form.anticipatedEndDate == null;
    }
    
    get isAnticipatedWorkDaysError(): boolean {
      return func.isNullOrEmptyOrZero(this.$props.form.anticipatedWorkDays);
    }
    
    get isAnticipatedWorkStartTimeError(): boolean {
      return func.isNullOrEmpty(this.$props.form.anticipatedWorkStartTime);
    }
    
    get isAnticipatedWorkEndTimeError(): boolean {
      return func.isNullOrEmpty(this.$props.form.anticipatedWorkEndTime);
    }

    get hasErrors(): boolean {
        return this.isFacilityNameError || this.isMonthsError || this.isFacilityTypeError || this.isApplicationDateError 
            || this.isAnticipatedStartDateError || this.isAnticipatedEndDateError || this.isAnticipatedWorkDaysError || this.isDivisionSiteIdError
            || this.isAnticipatedWorkStartTimeError || this.isAnticipatedWorkEndTimeError || this.isPropertyOwnerError || this.isApplicantContactError;
    }
}
